import { AxiosError } from "axios";

import "@/common/extensions/index";

export class AxiosHelper {
  public static isAxiosError(err: unknown): err is AxiosError {
    const axiosError = err as Nil<AxiosError>;
    return !!axiosError && axiosError.isAxiosError;
  }

  public static getAxiosErrorOrNull(err: unknown): AxiosError | null {
    return this.isAxiosError(err) ? err : null;
  }
}
